import { createFileRoute } from '@tanstack/react-router';
import { featureGuard } from 'router/featureGuard';
import { JwtFeature } from 'utility/jwt';
// TODO: gate on a real JwtFeature once backend assigns one. Admin items
// currently have no `feature` in the menu metadata — ungated beyond auth.
export const Route = createFileRoute('/_authenticated/admin/integrations')({
  beforeLoad: featureGuard(JwtFeature.Internal),
});
